{
  "Programcı": "Programmer",
  "menu": {
    "Admin": "Admin",
    "Href": "Href",
    "Menü Düzenle": "Edit Menu",
    "Menü Yönetimi": "Menu Management",
    "Programcı": "Programmer",
    "Silmek istediğinize emin misiniz? Alt menüler de silinecektir": "Are you sure you want to delete? Submenus will also be deleted.",
    "Sıralamayı Kaydet": "Save Order",
    "Virgül ile ayırın": "Separate with commas",
    "Yeni Menü Ekle": "Add New Menu",
    "Yetki Ayarları": "Permission Settings",
    "Yetki Kodları (Örn: 101002, 102002)": "Permission Codes (Ex: 101002, 102002)",
    "JSON format hatası: ": "JSON format hatası: ",
    "Yeni Menü": "Yeni Menü",
    "edit": "edit",
    "delete": "delete"
  }
}
